import { render, staticRenderFns } from "./MyBreakdown.vue?vue&type=template&id=202caa30&"
import script from "./MyBreakdown.vue?vue&type=script&lang=js&"
export * from "./MyBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports